// Адреса экранов приложения (memory-router). Только id — данные экран берёт сам.
// W1: матч-центр (вкладка matches), экран матча, меню; W4: «Уведомления» (/menu/notifications). W2–W3: у каждого экрана свой адрес и свой модуль (HQ-658);
// пока экрана нет, модуль — заглушка «Скоро». title — имя сущности для заголовка заглушки, если вызывающий его знает
// (строка таблицы, фишка игрока, заголовок лиги). Старые адреса /soon/<вид>/<id> перенаправляются на новые.

/** Виды экрана «Скоро»: сущность с номером, вкладка панели по ключу, поиск. */
export type SoonKind = 'team' | 'player' | 'league' | 'news' | 'highlight' | 'tab' | 'search';

/** Лига чемпионата мира (И-2.1 AC-7): у неё свой экран /world-cup. */
export const WORLD_CUP_LEAGUE_ID = 1;

const withTitle = (path: string, title?: string) => (title ? `${path}?title=${encodeURIComponent(title)}` : path);
const entity = (kind: string, id: number | string, title?: string) => withTitle(`/${kind}/${encodeURIComponent(String(id))}`, title);

export const paths = {
  /** Вкладка панели; live — матч-центр с включённым фильтром LIVE. */
  tab: (key: string, opts: { live?: boolean } = {}) => (opts.live ? `/tab/${key}?live=1` : `/tab/${key}`),
  match: (id: number | string) => `/match/${id}`,
  menu: () => '/menu',
  /** «Уведомления» — из меню и по кнопке бота (startapp=settings_push). */
  notifications: () => '/menu/notifications',
  team: (id: number | string, title?: string) => entity('team', id, title),
  player: (id: number | string, title?: string) => entity('player', id, title),
  /** Лига; чемпионат мира — свой экран /world-cup. */
  league: (id: number | string, title?: string) =>
    (String(id) === String(WORLD_CUP_LEAGUE_ID) ? withTitle('/world-cup', title) : entity('league', id, title)),
  news: (id: number | string, title?: string) => entity('news', id, title),
  highlight: (id: number | string, title?: string) => entity('highlight', id, title),
  search: () => '/search',
};

/** Старый адрес «Скоро» (/soon/<вид>/<id>?title=) → новый адрес экрана; незнакомый вид — null. */
export function fromSoonPath(kind: string | undefined, id: string | undefined, title: string | null): string | null {
  const name = title ?? undefined;
  if (kind === 'search') return paths.search();
  if (!id) return null;
  if (kind === 'tab') return paths.tab(id);
  if (kind === 'team' || kind === 'player' || kind === 'league' || kind === 'news' || kind === 'highlight') return paths[kind](id, name);
  return null;
}

/** Активная вкладка панели по адресу: /tab/<k> и /soon/tab/<k>; на вложенных экранах — null (та, из которой пришли). */
export function tabOfPath(pathname: string): string | null {
  const m = /^\/(?:tab|soon\/tab)\/([^/?]+)/.exec(pathname);
  return m ? decodeURIComponent(m[1]!) : null;
}

/** Начальная история: ссылка запуска — поверх вкладки по умолчанию («/»), чтобы BackButton вёл в неё. */
export function initialEntries(deepLink: string | null): { initialEntries: string[]; initialIndex: number } {
  return deepLink ? { initialEntries: ['/', deepLink], initialIndex: 1 } : { initialEntries: ['/'], initialIndex: 0 };
}

/** Ссылка на Mini App в боте (экран «Откройте в Telegram»): t.me/<бот>/<короткое имя>. */
export function telegramLink(bot: string, app: string): string {
  return bot ? `https://t.me/${bot}${app ? `/${app}` : ''}` : 'https://t.me/';
}
